export default __webpack_public_path__ + "static/media/pin-landscape-transparent.215d92b0.png";